<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <!-- BOC:[error] -->
    <AError
      v-if="api.isError"
      :api="api"
      :callbackReset="() => (api.isError = false)"
    ></AError>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col><h2>Disable Auto Renewal</h2></v-col>
      </v-row>
      <v-card-title></v-card-title>
      <div class="d-flex align-center justify-space-around">
        <div class="form-content text-left">
          <v-alert border="bottom" colored-border type="error" elevation="2">
            This action is irreversible. Are you sure you want to disable auto renewal?
             <p class="text--secondary">
            This action will disable auto renewal your current subscription plan. You will continue to have access until the end of your current billing period.
          </p>
          </v-alert>
          <div class="text-right">
            <v-btn color="error" class="mr-4" @click="submit" :loading="deleteApi.isLoading" text> Yes </v-btn>
            <v-btn text @click="close"> No </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  // computed: mapState({
  //     auth: (state) => state.auth.data,
  //   }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    deleteApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    name: null,
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs.push({
      text: "Dashboard",
      to: { name: "PageEducatorDashboard" },
      exact: true,
    });
    this.breadcrumbs.push({
      text: "My Plan",
      to: {
        name: "PageEducatorPlanRead",
      },
      exact: true,
    });
    this.breadcrumbs.push({
      text: "Disable auto Renewal",
      to: {
        name: "PageEducatorPlanAutoRenewalStop",
      },
      exact: true,
    });
    //EOC
    this.deleteApi.url =
       this.$api.servers.sso + "/api/v1/" + this.$_getLocale() + "/backend/account/plan/cancel";

    this.deleteApi.callbackReset = () => {
      this.deleteApi.isLoading = true;
      this.deleteApi.isError = false;
    };

    this.deleteApi.callbackError = (e) => {
      this.deleteApi.isLoading = false;
      this.deleteApi.isError = true;
      this.deleteApi.error = e;
    };

    this.deleteApi.callbackSuccess = () => {
      this.deleteApi.isLoading = false;
      this.$router.push({ name: "PageEducatorPlanRead" });
    };
  },
  mounted() {
  },
  methods: {

    submit() {
      this.deleteApi.params = {
        id: this.$route.params.id,
      };
      this.$api.fetch(this.deleteApi);
    },
    close() {
      this.$router.push({ name: "PageEducatorUserRead",params: { id: this.$route.params.id }, });
    },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>